export default "__VITE_ASSET__Dx$EqtqW__"